define('C3.ShoppingExtensions.ViewInventory.Collection',
  [
  'C3.ShoppingExtensions.ViewInventory.Model',
  'Utils',
  'SCCollection',
  'SCModel',
  'underscore'
  ],
  function (ViewInventoryModel, Utils,SCCollectionModule,SCModelModule,_) {
    'use strict';

     var SCCollection = SCCollectionModule.SCCollection;
     var SCModel = SCModelModule.SCModel;


     function ViewInventoryCollection(models, options) {
      SCCollection.call(this, models, options);

      this.model = SCModel;

      this.customFilters = options && options.filters;


      this.url = function url () {
        return Utils.getAbsoluteUrl(
                getExtensionAssetsPath(
                    "services/ViewInventory.Service.ss"
                )
              )
      }

       this.parse = function parse(response) {
        this.totalRecordsFound = response.totalResultsCount;
        this.recordsPerPage = 50;
        //this.resourceCategory = response.resourceCategory
        var final_data = {
          searchResults : response.searchResults,
          searchColLabels : response.searchColLabels,
          responseStatus : response.responseStatus
        }
        return final_data;
      }

      this.update = function update(options){
         const data = {
              filter: options.filter,
              pageNumber: options.page || 1,
              resultsPerPage: options.resultsPerPage || 50,
              keyword : options.keyword
          };

         // console.log(data)
          
          this.fetch({
              data: data,
              reset: true,
              killerId: options.killerId
          });
      }
    }

    ViewInventoryCollection.prototype = Object.create(SCCollection.prototype);
    ViewInventoryCollection.prototype.constructor = ViewInventoryCollection;

    return ViewInventoryCollection;
    
  }
);
